const reportCallbackError = (eventName, errorReporter) => e => {
  errorReporter(`An error occurred in one of ${eventName} callbacks`, e)
}

exports.reportCallbackError = reportCallbackError



// WEBPACK FOOTER //
// ./error-boundaries/reportCallbackError.js